<template>
  <div>
    <div class="row">
      <div class="col-sm-12 padding-top">
        <div class="panel panel-default">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a>
              <i
                class="fa"
                :class="{
                  'fa fa-ban': !certificado.status,
                  'fa-plus': collapsed && certificado.status,
                  'fa-minus': !collapsed && certificado.status
                }"
              ></i>
              Certificado
            </a>
          </div>
          <div class="panel-body" v-show="!collapsed" v-if="certificado.status">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="cnpj">CNPJ Anexo:</label>
                  <div class="input-group">
                    <span class="form-control" :disabled="true">{{
                      certificado.empresa.cnpj | cpfCnpj
                    }}</span>
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="certificado.empresa.cnpj"
                        title="Copiar"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="dtVenc">Vencimento:</label>
                  <span class="form-control" :disabled="true">{{
                    certificado.validade | date
                  }}</span>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="dtVenc">Senha:</label>
                  <div class="input-group">
                    <span class="form-control" :disabled="true">{{ certificado.senha }}</span>
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="certificado.senha"
                        title="Copiar"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="dtVenc">Dias para Expirar:</label>
                  <span class="form-control" :disabled="true">{{ certificado.diasExpirar }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <button
                  type="button"
                  class="btn btn-sm btn-warning"
                  title="Efetuar Transferência do Certificado"
                  @click.prevent="download"
                >
                  <i class="fa fa-download"></i> Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputData from '../../components/Inputs/InputData.vue'
import Certificado from '../Certificado/Index.vue'

export default {
  name: 'empresa-certificado',
  extends: Certificado,
  props: {
    empresa: {
      required: true
    }
  },
  data() {
    return {
      collapsed: true,
      certificado: { empresa: {} }
    }
  },
  computed: {
    empresaSelecionada() {
      return Object.assign({}, this.empresa)
    }
  },
  components: {
    InputData
  }
}
</script>

<style lang="css" scoped>
a {
  color: #3c8dbc !important;
}
</style>
